export const tabs = () => {
  const tabs = document.querySelectorAll("[data-tabs]");

  const changeTab = (item, headerItems) => {
    const tabName = item.parentNode.getAttribute("data-tabs-name");
    let currentItem = item;
    headerItems.forEach((element) => {
      element.classList.remove("isActive");
    });
    currentItem.classList.add("isActive");
    let dataItem = currentItem.getAttribute("data-tabs-header-item");

    const currentContents = document.querySelectorAll(
      `[data-tabs-name="${tabName}"] .tabs-content__item`
    );
    const currentImages = document.querySelectorAll(
      `[data-tabs-name="${tabName}"] .tabs-image`
    );
    currentContents.forEach((content) => {
      content.classList.remove("isActive");
      if (content.getAttribute("data-tabs-content-item") === dataItem) {
        content.classList.add("isActive");
      }
    });
    currentImages.forEach((content) => {
      content.classList.remove("isActive");
      if (content.getAttribute("data-tabs-image-item") === dataItem) {
        content.classList.add("isActive");
      }
    });
  };
  tabs.forEach((element) => {
    const tabsItems = element.querySelectorAll(".tabs-header__item");
    tabsItems.forEach((item, index) => {
      item.addEventListener("click", (e) => {
        changeTab(item, tabsItems);
      });
    });
    if (tabsItems.length > 0) {
      const firstItem = tabsItems[0];
      changeTab(firstItem, tabsItems);
    }
  });
};
